/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Id/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Id({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/Content/SimilarPerson/Person/Details/Content/Id"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let similarPersonPatientHumanReadableIdValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'patient.human_readable_id',
})
let similarPersonPatientLegacyIdValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'patient.legacy_id',
})
let aggregateData = fromHelpers.getPatientId(similarPersonPatientHumanReadableIdValueData, similarPersonPatientLegacyIdValueData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Id.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-CJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Patient Id"
 weight="semibold"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 data="similar_person.patient.human_readable_id"
 data="similar_person.patient.legacy_id"
 aggregate="helpers.js getPatientId"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}